import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import {
    captureException,
    getActiveTransaction,
    init as sentryInit,
    routingInstrumentation,
    Replay,
} from '@sentry/angular';
import { AppModule } from './app/app.module';
import { ENV, ENV_URLS } from './environments/environment';
import { Integrations } from '@sentry/tracing';
import { sentry_dsn } from './app/constant/constant';

if (ENV.production) {
    enableProdMode();
}

const activeTransaction = getActiveTransaction();
const bootstrapSpan =
    activeTransaction &&
    activeTransaction.startChild({
        description: 'platform-browser-dynamic',
        op: 'ui.angular.bootstrap'
    });

sentryInit({
    dsn: sentry_dsn,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 0.77,
    integrations: [
        new Integrations.BrowserTracing({
            // tracingOrigins: ['localhost'],
            routingInstrumentation: routingInstrumentation
        }),
        new Replay(),
    ],
    environment: ENV.environment_type,
    enabled: ENV.sentry_enabled,
    release: ENV.app_version,
    tunnel: `${ENV_URLS.API_BASE_URL}api/sentry/tunnel`
});

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => captureException(err))
    .finally(() => {
        if (bootstrapSpan) {
            bootstrapSpan.finish();
        }
    });
